/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module HttprequestTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Httprequest {
    [k: string]: any;
}
/**
 * A single (key-value pair)
 *
 * This interface was referenced by `Httprequest`'s JSON-Schema
 * via the `definition` "KeyValue".
 */
export interface KeyValue {
    keyName: string;
    keyValue: string;
}
/**
 * This interface was referenced by `Httprequest`'s JSON-Schema
 * via the `definition` "Failure".
 */
export interface Failure {
    exception?: string;
    message?: string;
    code?: number;
    networkError?: boolean;
}
/**
 * This interface was referenced by `Httprequest`'s JSON-Schema
 * via the `definition` "RequestParams".
 */
export interface RequestParams {
    requestId: number;
    url: string;
    body?: string;
    requestCache?: RequestCache;
    headers?: KeyValue[];
    httpRequestType: HttpRequestType;
    origin?: string;
    requestRedirect?: RequestRedirect;
    userAgent?: string;
}
/**
 * This interface was referenced by `Httprequest`'s JSON-Schema
 * via the `definition` "Response".
 */
export interface Response {
    requestId: number;
    statusText?: string;
    status?: number;
    body?: string;
    responseHeaders?: KeyValue[];
    url?: string;
    cancelled?: boolean;
    failure?: Failure;
}
/**
 * This interface was referenced by `Httprequest`'s JSON-Schema
 * via the `definition` "CancelHttpRequestParameters".
 */
export interface CancelHttpRequestParameters {
    /**
     * Describes requestId
     */
    requestId: number;
}

export enum RequestCache {
    default = 'default',
    force_cache = 'force-cache',
    no_cache = 'no-cache',
    no_store = 'no-store',
    only_if_cached = 'only-if-cached',
    reload = 'reload'
}
export enum HttpRequestType {
    GET = 'GET',
    HEAD = 'HEAD',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}
export enum RequestRedirect {
    follow = 'follow',
    error = 'error',
    manual = 'manual'
}


}
